import React from "react"
import {
  SUPPORT_PHONE_1_HREF,
  SUPPORT_PHONE_1_TEXT,
  SUPPORT_PHONE_2_HREF,
  SUPPORT_PHONE_2_TEXT,
} from "../config/supportContact"

type Props = { linkClassName?: string }

/** Renders both support lines as separate tel: links with " / " between. */
export function SupportPhonePair({ linkClassName }: Props) {
  return (
    <>
      <a href={SUPPORT_PHONE_1_HREF} className={linkClassName}>
        {SUPPORT_PHONE_1_TEXT}
      </a>
      {" / "}
      <a href={SUPPORT_PHONE_2_HREF} className={linkClassName}>
        {SUPPORT_PHONE_2_TEXT}
      </a>
    </>
  )
}
